export default function (selector, func) {
    let target = document.querySelectorAll(selector);
    let lastTarget = target[target.length - 1];

    if(lastTarget !== null){
        let io = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    func();
                    io.unobserve(lastTarget);
                }
            },
            {}
        );
        io.observe(lastTarget);
    }
}